/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOflong
 */
export interface ApiResultOflong {
    /**
     * 
     * @type {number}
     * @memberof ApiResultOflong
     */
    data?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOflong
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOflong
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOflong
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOflong
     */
    result?: ApiResultOflongResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOflongResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOflongFromJSON(json: any): ApiResultOflong {
    return ApiResultOflongFromJSONTyped(json, false);
}

export function ApiResultOflongFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOflong {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOflongToJSON(value?: ApiResultOflong | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

